import { useNavigableContext } from './context'
import { Item, NavigableItemApi } from './types'

export function useNavigableItem<IDENTIFIER>(item: Item<IDENTIFIER>): NavigableItemApi<IDENTIFIER> {
  const register = useNavigableContext()
  return register(item)
}
